import { requiredCheck } from '@ztechapps/common.utils'
import { getOperationName } from '@apollo/client/utilities'
import isEmpty from 'lodash/isEmpty'
import merge from 'lodash/merge'
import type { UseDocumentProps } from './index'

export function useBuildDocumentQueryOptions<T = any>({
  query,
  filter,
  _id,
  options,
  entity,
}: Pick<UseDocumentProps<T>, 'query' | 'filter' | '_id' | 'options' | 'entity'>) {
  requiredCheck(query, 'useDocument.query')
  //entity can be derived from the operations automatically
  if (!entity) {
    entity = getOperationName(query)
  }

  //if id is specified override the filter, and filter it by _id
  //also if the _id is null, we filter it with null value
  if (!isEmpty(_id) || _id === null) {
    filter = { _id }
  }

  //we skip the the query if there is nno value for the filter and _id is undefined,
  //but still it can be overriden by the options
  const defaultSkip = _id === undefined && filter === undefined

  if (defaultSkip) {
    console.warn(`WARNING: (defaultSkip) The filter is not defined, same as the _id object so it will be skip automatically for [${entity}]`)
  }

  options = merge(
    {
      queryOptions: {
        skip: defaultSkip,
      },
    },
    options
  )

  //always the first item on the query will be the result
  const skip = 0
  const limit = 1

  return {
    filter,
    entity,
    defaultSkip,
    options,
    skip,
    limit,
    query,
  }
}
